module.exports = __webpack_public_path__ + "img/Technischer_Zug_mit_FGr_Trinkwasser.c5983bf7.svg";